import React, { useState, useRef } from 'react'
import { Helmet } from 'react-helmet'
import Preloader from '../components/Preloader'
import Footer from '../components/Footer';
import ScrollReveal from '../components/ScrollReveal';
import Header from '../components/Header';
import { FaTimes, FaBriefcase, 
// FaPaperPlane
 } from 'react-icons/fa';

const jobs = [
    {
        id: 1,
        title: "Administrative Assistant",
        image: "/assets/administrative-assistance-role.jpg",
        description: "Querencia Microcredit is looking for a highly organized, proactive, and customer-focused Administrative Assistant to support the day-to-day operations of our office.",
        vacancy: "Administrative Assistant",
        deadline: "Friday August 7th, 2026",
        responsibilities: [
            "Welcome and assist clients and visitors professionally.",
            "Answer phone calls, respond to inquiries and direct communication appropriately.",
            "Prepare, organize and maintain office files and records.",
            "Assist with data entry, document preparation and report generation.",
            "Schedule appointments and coordinate meetings",
            "Receive and process customer applications and supporting documents",
            "Manage office suppliers and ensure the office remain organized",
            "Provide adminisrative support to management and other department as assigned",
            "Maintain confidentiality of company and client information",
        ],
        howToApply: "Interested applicants should send their CV to: admin.hr@querenciamc.com or submit it at our office near Adenta Roundabout.",
        requirements: [
            "Minimun qualification: Senior High School (SHS) Certificate. A Diploma or HND in Business Administration, or a related field in an added advantage.",
            "Proficient in Microsoft Office Suite (Word, Excel, PowerPoint, Outlook).",
            "Excellent communication and interpersonal skills",
            "Strong organizational and time management abilities",
            "Attention to detail and high level of professionalism",
            "Abilities to work independently and as part of a team.",
            "Previous administrative or customer service experience is an added advantage.",
        ],
        whatWeOffer: [
            "Competitive salary.",
            "Opportunities for training and career growth.",
            "A supportive and professional work environment.",
        ],
    },
    {
        id: 2,
        title: "Credit & Sales Officer",
        image: "/assets/creditandsaleofficer-role.jpg",
        description: "Querencia Microcredit is seeking energetic, honest, and target-driven individuals to join our team as Credit and Sales officers",
        vacancy: "Credit & Sales Officer",
        deadline: "Friday August 7th, 2026",
        responsibilities: [
            "Identify and recruit new customers for the company's loan products.",
            "Market and promote the company's financial services.",
            "Assess customers eligibility for loan through basic credit and background checks.",
            "Assist customer with loan applications and required documentation.",
            "Build and maintain strong relationships with clients",
            "Monitor loan repayments and follow up on overdue accounts",
            "Support loan recovery activities where necessary.",
            "Meet assigned sales and portfolio growth targets.",
            "Prepare and submit daily, weekly and monthly activities reports.",
        ],
        howToApply: "Interested applicants should send their CV to: admin.hr@querenciamc.com or submit it at our office near Adenta Roundabout.",
        requirements: [
            "Mininum qualification: Senior High School (SHS) Certificate.",
            "Previous experience in sales, customer service, or microfinance is an added advantage but not required.",
            "Excellent in communication and interpersonal skills.",
            "Honest, confident, and self-motivated.",
            "Ability to work under pressure and meet targets",
            "Must be willing to travel within assigned areas for customer engagement.",
        ],
        whatWeOffer: [
            "Competitive salary.",
            "Attractive performance-based commissions and incentives.",
            "continuous training and career growth opportunites.",
            "A supportive and work environment.",
        ],
    },
    // {
    //     id: 3,
    //     title: "Relationship Officer",
    //     image: "/assets/job3.jpeg",
    //     description: "A rapidly expanding micro‑credit institution based in Adenta, Accra, is seeking a motivated Relationship Officer.",
    //     vacancy: "Relationship Officer",
    //     deadline: "Friday August 7th, 2026",
    //     responsibilities: [
    //         "Build and maintain strong client relationships.",
    //         "Promote the institution's products and services.",
    //         "Address client inquiries and resolve issues.",
    //         "Assist with loan origination and monitoring."
    //     ],
    //     howToApply: "Interested applicants should send their CV to: admin.hr@querenciamc.com or submit it at our office near Adenta Roundabout.",
    //     requirements: [
    //         "HND (or higher) in Marketing, Business, Finance or a related field.",
    //         "At least 1 year of relevant work experience (financial services experience preferred).",
    //         "Strong command of Microsoft Office suite (Word, Excel, PowerPoint, etc.)."
    //     ]
    // }
];

const Career = () => {
    const [selectedJob, setSelectedJob] = useState(null);
    const [formJobTitle, setFormJobTitle] = useState('');
    const formRef = useRef(null);

    const handleApply = (job) => {
        setFormJobTitle(job.title);
        setSelectedJob(null);
        setTimeout(() => {
            formRef.current?.scrollIntoView({ behavior: 'smooth' });
        }, 100);
    };

    return (
        <div className='font-nixie-one bg-white min-h-screen text-gray-800'>
            <Helmet>
                <title>Career - Querencia Micro Credit</title>
                <meta name="description" content="Join our team at Querencia Micro Credit. Explore exciting career opportunities and help us empower individuals and businesses in Ghana." />
                <meta name="keywords" content="career, jobs, employment, micro credit, Ghana, finance jobs, Querencia" />
                <meta property="og:title" content="Career - Querencia Micro Credit" />
                <meta property="og:description" content="Join our team at Querencia Micro Credit. Explore exciting career opportunities and help us empower individuals and businesses in Ghana." />
            </Helmet>
            <Header />
            <Preloader />
            <main>
                {/* Hero Section */}
                <section className="relative h-[40vh] md:h-[50vh] bg-cover bg-center" style={{ backgroundImage: "url('/assets/career.jpg')" }}>
                    <div className="absolute inset-0 bg-blue-900/60 flex items-center justify-center">
                        <ScrollReveal animationClass="animate-fade-up" threshold={0.1} delay={200}>
                            <div className="text-center text-white px-4">
                                <h1 className="text-2xl md:text-3xl font-bold mb-4 capitalize tracking-wide">Career</h1>
                                <p className="text-sm md:text-sm max-w-2xl mx-auto font-light">
                                    Join our team and help us make a difference in the lives of many across Ghana. Explore exciting career opportunities with us.
                                </p>
                            </div>
                        </ScrollReveal>
                    </div>
                </section>

                {/* Job Listings Section */}
                <section className="py-16 px-4 container mx-auto">
                    <ScrollReveal animationClass="animate-fade-up" threshold={0.1}>
                        <div className="text-center mb-12">
                            <h2 className="text-2xl font-bold text-blue-900 mb-4">Current Openings</h2>
                            <p className="text-gray-600 max-w-2xl mx-auto text-sm font-semibold">
                                We are always looking for talented individuals to join our growing team. Check out our current vacancies below.
                            </p>
                        </div>
                    </ScrollReveal>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {jobs.map((job) => (
                            <ScrollReveal key={job.id} animationClass="animate-fade-in" threshold={0.1}>
                                <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 border border-gray-100 flex flex-col h-full">
                                    <div className="h-48 overflow-hidden">
                                        <img
                                            src={job.image}
                                            alt={job.title}
                                            className="w-full h-full object-cover transition-transform duration-500 hover:scale-110"
                                            loading='lazy'
                                        />
                                    </div>
                                    <div className="p-6 flex flex-col flex-grow">
                                        <h3 className="text-xl font-bold text-blue-900 mb-2">{job.title}</h3>
                                        <p className="text-gray-600 text-sm mb-2 flex-grow font-semibold">{job.description}</p>
                                        <span className="text-gray-600 text-sm mb-4 flex-grow font-semibold">Deadline: {job.deadline}</span>
                                        <button
                                            onClick={() => setSelectedJob(job)}
                                            className="mt-auto w-full py-2 px-4 bg-blue-600 text-white rounded-md font-semibold hover:bg-blue-700 transition-colors duration-300 flex items-center justify-center gap-2 text-sm"
                                        >
                                            Read More <FaBriefcase />
                                        </button>
                                    </div>
                                </div>
                            </ScrollReveal>
                        ))}
                    </div>
                </section>

                {/* Application Form Section */}
                {/* <section ref={formRef} className="py-16 px-4 bg-gray-50">
                    <div className="container mx-auto max-w-3xl">
                        <ScrollReveal animationClass="animate-fade-up" threshold={0.1}>
                            <div className="text-center mb-10">
                                <h2 className="text-2xl font-bold text-blue-900 mb-4">Apply for a Position</h2>
                                <p className="text-gray-600 text-sm font-semibold">
                                    Ready to join us? Fill out the form below and we will get back to you.
                                </p>
                            </div>
                        </ScrollReveal>

                        <ScrollReveal animationClass="animate-fade-in" threshold={0.1} delay={200}>
                            <div className="bg-white rounded-xl shadow-lg p-8 border border-gray-100">
                                <form className="space-y-6" action={'https://formsubmit.co/admin.hr@querenciamc.com'} method="POST" encType="multipart/form-data">
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                        <div>
                                            <label htmlFor="fullName" className="block text-gray-700 text-sm font-bold mb-2">Full Name <span className="text-red-500">*</span></label>
                                            <input type="text" name='fullName' id="fullName" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 transition-colors text-sm" placeholder="John Doe" required />
                                        </div>
                                        <div>
                                            <label htmlFor="email" className="block text-gray-700 text-sm font-bold mb-2">Email Address <span className="text-red-500">*</span></label>
                                            <input type="email" name='email' id="email" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 transition-colors text-sm" placeholder="john@example.com" required />
                                        </div>
                                    </div>

                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                        <div>
                                            <label htmlFor="phone" className="block text-gray-700 text-sm font-bold mb-2">Phone Number <span className="text-red-500">*</span></label>
                                            <input type="tel" name='phoneNumber' id="phone" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 transition-colors text-sm" placeholder="+233 20 000 0000" required />
                                        </div>
                                        <div>
                                            <label htmlFor="position" className="block text-gray-700 text-sm font-bold mb-2">Position Applying For <span className="text-red-500">*</span></label>
                                            <div className="relative">
                                                <select
                                                    id="position"
                                                    name='position_applying_for'
                                                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 transition-colors text-sm appearance-none bg-white"
                                                    value={formJobTitle}
                                                    onChange={(e) => setFormJobTitle(e.target.value)}
                                                    required
                                                >
                                                    <option value="" disabled className='font-semibold '>Select a position</option>
                                                    {jobs.map(job => (
                                                        <option key={job.id} value={job.title} className='font-semibold '>{job.title}</option>
                                                    ))}
                                                    <option value="Other" className='font-semibold '>Other</option>
                                                </select>
                                                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-3 text-gray-700">
                                                    <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" /></svg>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <label htmlFor="cv" className="block text-gray-700 text-sm font-bold mb-2">Upload CV/Resume <span className="text-red-500">*</span></label>
                                        <input type="file" name='cv' id="cv" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 transition-colors text-sm file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100" accept=".pdf,.doc,.docx" required />
                                        <p className="text-xs text-gray-500 mt-1 font-semibold">Accepted formats: PDF, DOC, DOCX. Max size: 5MB.</p>
                                    </div>

                                    <div>
                                        <label htmlFor="coverLetter" className="block text-gray-700 text-sm font-bold mb-2">Cover Letter</label>
                                        <textarea id="coverLetter" name='coverLetter' rows="4" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 transition-colors text-sm" placeholder="Tell us why you are a good fit for this role..."></textarea>
                                    </div>

                                    <input type="hidden" name="_next" value="https://querenciamicrocredit.onrender.com/careersubmission"></input>
                                    <input type="hidden" name="_autoresponse" value="Thank you for applying to this role at QUERENCIA MICRO CREDIT! We have succesfully received your application.Our recruitment team will review your application and get back to you as soon as possible. Please note that only successfull applicants will be contacted."></input>
                                    <input type="hidden" name="_template" value="box"></input>

                                    <div className="text-center pt-4">
                                        <button type="submit" className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-8 rounded-full transition-all duration-300 shadow-md hover:shadow-lg flex items-center justify-center gap-2 mx-auto text-sm">
                                            Submit Application <FaPaperPlane />
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </ScrollReveal>
                    </div>
                </section> */}

                {/* Job Details Modal */}
                {selectedJob && (
                    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm transition-opacity duration-300 animate-fade-in" onClick={() => setSelectedJob(null)}>
                        <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden animate-slide-up relative" onClick={(e) => e.stopPropagation()}>
                            <button
                                onClick={() => setSelectedJob(null)}
                                className="absolute top-4 right-4 text-gray-500 hover:text-red-500 transition-colors focus:outline-none bg-gray-100 rounded-full p-1"
                            >
                                <FaTimes size={20} />
                            </button>

                            <div className="bg-blue-900 p-6 text-white">
                                <h3 className="text-xl font-bold">{selectedJob.title}</h3>
                                <div className="flex flex-wrap gap-4 mt-2 text-blue-200 text-xs font-semibold uppercase tracking-wider">
                                    <span>Vacancy: {selectedJob.vacancy}</span>
                                    <span>Deadline: {selectedJob.deadline}</span>
                                </div>
                            </div>

                            <div className="p-6 md:p-8 max-h-[60vh] overflow-y-auto">
                                <div className="mb-6">
                                    <h4 className="font-bold text-black mb-2 text-sm">Description</h4>
                                    <p className="text-gray-600 text-sm font-semibold">{selectedJob.description}</p>
                                </div>

                                <div className="mb-6">
                                    <h4 className="font-bold text-black mb-2 text-sm">Key Responsibilities</h4>
                                    <ul className="space-y-2">
                                        {selectedJob.responsibilities.map((resp, index) => (
                                            <li key={index} className="flex items-start gap-2 text-gray-600 text-sm font-semibold">
                                                <span className="mt-1.5 w-1.5 h-1.5 bg-blue-500 rounded-full flex-shrink-0"></span>
                                                <span>{resp}</span>
                                            </li>
                                        ))}
                                    </ul>
                                </div>

                                <div className="mb-6">
                                    <h4 className="font-bold text-black mb-2 text-sm">Requirements</h4>
                                    <ul className="space-y-2">
                                        {selectedJob.requirements.map((req, index) => (
                                            <li key={index} className="flex items-start gap-2 text-gray-600 text-sm font-semibold">
                                                <span className="mt-1.5 w-1.5 h-1.5 bg-blue-500 rounded-full flex-shrink-0"></span>
                                                <span>{req}</span>
                                            </li>
                                        ))}
                                    </ul>
                                </div>

                                <div className="mb-6">
                                    <h4 className="font-bold text-black mb-2 text-sm">What We Offer</h4>
                                    <ul className="space-y-2">
                                        {selectedJob.whatWeOffer.map((req, index) => (
                                            <li key={index} className="flex items-start gap-2 text-gray-600 text-sm font-semibold">
                                                <span className="mt-1.5 w-1.5 h-1.5 bg-blue-500 rounded-full flex-shrink-0"></span>
                                                <span>{req}</span>
                                            </li>
                                        ))}
                                    </ul>
                                </div>

                                <div className="mb-6">
                                    <h4 className="font-bold text-black mb-2 text-sm">How to Apply</h4>
                                    <p className="text-gray-600 text-sm font-semibold">
                                        {selectedJob.howToApply.split('admin.hr@querenciamc.com')[0]}
                                        <a href="mailto:admin.hr@querenciamc.com" className="text-blue-600 hover:underline">admin.hr@querenciamc.com</a>
                                        {selectedJob.howToApply.split('admin.hr@querenciamc.com')[1]}
                                    </p>
                                </div>

                                {/* <div className="mt-8 pt-4 border-t border-gray-100 text-center">
                                    <button onClick={() => handleApply(selectedJob)} className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-8 rounded-full transition-colors text-sm">
                                        Apply Now
                                    </button>
                                </div> */}
                                <div className="mt-8 pt-4 border-t border-gray-100 text-center">
                                    <button className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-8 rounded-full transition-colors text-sm">
                                        <a href={`mailto:admin.hr@querenciamc.com`} target="_self" rel="noopener noreferrer">Apply Now</a>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </main>
            <Footer />
        </div>
    )
}

export default Career
